import React from 'react'
import {base} from 'lib/styleguide/base.scss'
import {GlobalNav} from 'common/GlobalNav'
import styles from './NavbarDemo.scss'
import {Link} from 'react-router'
import {getCurrentUser} from 'lib/utils'
import cx from 'classnames'

const you = getCurrentUser()
const user = {
  id: you.id || 718588,
  accountLevel: 0,
  highlightedPhotoId: you.highlightedPhotoId || 2225934,
  numUnreadMessages: 0
}

const LOGGED_OUT_USER = {
}

const FREE_USER = {
  ...user,
  accountLevel: 0
}

const PAID_USER = {
  ...FREE_USER,
  accountLevel: 1
}

const PAID_USER_UNREAD = {
  ...PAID_USER,
  numUnreadMessages: 1
}

export class NavbarDemo extends React.PureComponent {
  render () {
    return (
      <div className={cx(base, styles.NavbarDemo)}>
        <div className={styles.toolbar}>
          <Link to='/styleguide/navbar'>&laquo; Back to styleguide</Link>
          <span className={styles.mobileHint}>
            Use <a href='https://developers.google.com/web/tools/chrome-devtools/device-mode/'>device mode</a>  to test mobile styles
          </span>
        </div>
        <h1>Logged-out Navbar</h1>
        <GlobalNav currentUser={LOGGED_OUT_USER} />

        <h1>Free User Navbar</h1>
        <GlobalNav currentUser={FREE_USER} />

        <h1>Paid User Navbar</h1>
        <GlobalNav currentUser={PAID_USER} />

        <h1>Paid User Navbar with Unread</h1>
        <GlobalNav currentUser={PAID_USER_UNREAD} />
      </div>
    )
  }
}
